"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCallAndBackfeed = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var useJSBridgeInstance_1 = require("./useJSBridgeInstance");
/**
 * 执行自定义 scheme 指令。
 * @param scheme
 * @returns
 */
function useCallAndBackfeed(scheme) {
    var _this = this;
    var jsBridge = (0, useJSBridgeInstance_1.useJSBridgeInstance)();
    var _a = React.useState(null), state = _a[0], setState = _a[1];
    React.useEffect(function () {
        var asyncFunc = function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var res;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, jsBridge.callAndBackfeed(scheme)];
                    case 1:
                        res = (_a.sent())[0];
                        if (res) {
                            setState(res);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        asyncFunc();
    }, [jsBridge, scheme, state]);
    return state;
}
exports.useCallAndBackfeed = useCallAndBackfeed;
//# sourceMappingURL=useCallAndBackfeed.js.map